import { App } from 'features/apps/types'

import { usePatchAppMutation } from 'features/apps/hooks/appsHooks'
import AppsShareDialogUi, { AppSharingOptions } from './AppShareDialogUi'

interface AppsShareDialogProps {
  app: App
  open: boolean
  onClose: () => void
}

function AppsShareDialog({ app, open, onClose }: AppsShareDialogProps) {
  const { mutateAsync: patchApp, isLoading: isUpdating } = usePatchAppMutation()

  const handleChange = async (privacyUpdate: Partial<AppSharingOptions>) => {
    try {
      await patchApp({ id: app.id, ...privacyUpdate })
    } catch {
      // error handling using `error` variable
      throw new Error('Error updating app sharing options')
    }
  }

  return <AppsShareDialogUi open={open} onClose={onClose} app={app} isUpdating={isUpdating} onChange={handleChange} />
}

export default AppsShareDialog
